import React, { useEffect, useState } from 'react'
import Contenido from './components/Contenido'
import { autorizacionesAdapter } from '../../services/adapters/autorizaciones.adapter'
import { getAutorizaciones } from '../../services/mis-solicitudes/solicitudesService'

export default function Autorizaciones() {
    const [misAutorizaciones, setMisAutorizaciones] = useState([])
    const [tabSelected, setTabSelected] = useState(() => {
        const storedTab = sessionStorage.getItem('tabSelectedAutorizaciones');
        return storedTab ? JSON.parse(storedTab) : { text: "Pendientes", id: "pendientes" };
    });

    async function getMisAutorizaciones(grupo) {
        return getAutorizaciones(grupo)
    }

    useEffect(() => {
        sessionStorage.setItem('tabSelectedAutorizaciones', JSON.stringify(tabSelected));
        setMisAutorizaciones([])
        const init = async () => {
            const misAutorizacionesData = await getMisAutorizaciones(tabSelected?.id)
            let misSolicitudesDataAdapted = misAutorizacionesData?.data.length > 0 ? autorizacionesAdapter(misAutorizacionesData) : [];
            setMisAutorizaciones(misSolicitudesDataAdapted.rows);
        }

        init()
    }, [tabSelected])


    return <Contenido data={misAutorizaciones?.length > 0 ? misAutorizaciones : []} tabSelected={tabSelected} setTabSelected={setTabSelected} />
}
